'use strict';

var React = require('react'),
    _ = require('underscore'),
    classSet = require('react/lib/cx'),
    PopupManager = require('../utils/PopupManager'),
    FormMixin = require('../mixins/FormMixin'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    Textarea = require('../atoms/Textarea'),
    FormInputRow = require('../molecules/FormInputRow'),
    TagInput = require('../molecules/TagInput'),
    ContactImporter = require('../molecules/ContactImporter'),
    ContactList = require('../organisms/ContactList'),
    InviteList = require('../organisms/InviteList'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    isValidEmail = require('../utils/isValidEmail'),
    ServiceTypes = require('../constants/ServiceTypes'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    InvitationStore = require('../stores/InvitationStore'),
    InvitationActionCreators = require('../actions/InvitationActionCreators'),
    FacebookManager = require('../utils/FacebookManager'),
    FacebookActionCreators = require('../actions/FacebookActionCreators'),
    SendInvitationFormStore = require('../stores/SendInvitationFormStore'),
    SocialFriendListStore = require('../stores/SocialFriendListStore'),
    SentInvitationStore = require('../stores/SentInvitationStore'),
    UserStore = require('../stores/UserStore'),
    SendInvitationFormActionCreators = require('../actions/SendInvitationFormActionCreators');

require('./SendInvite.less');

var SendInvite = React.createClass({
  mixins: [FormMixin, PureRenderMixin, createStoreMixin(InvitationStore, SendInvitationFormStore, SocialFriendListStore, UserStore)],

  propTypes: {
    title: React.PropTypes.string.isRequired,
    zineSlug: React.PropTypes.string,
    onCloseClick: React.PropTypes.func.isRequired
  },

  getStateFromStores() {
    return _.extend(SendInvitationFormStore.getFormState(), {
      invited: SentInvitationStore.getInvitations(),
      isFacebookConnected: !!SocialFriendListStore.getFriends(ServiceTypes.FACEBOOK),
      isGoogleConnected: !!SocialFriendListStore.getFriends(ServiceTypes.GOOGLE),
    });
  },

  componentDidMount: function () {
    FacebookManager.init();

    InvitationActionCreators.requestInvitationsPage(true);
    InvitationActionCreators.requestSocialFriendsPage(ServiceTypes.FACEBOOK);
    InvitationActionCreators.requestSocialFriendsPage(ServiceTypes.GOOGLE);
  },

  render: function () {
    var forZine = !!this.props.zineSlug,
        invited = this.state.invited,
        classes;

    classes = classSet({
      'Modal-body': true,
      'Modal-body--wide': true,
      'Modal-body--hidden': this.state.isFormHidden
    });

    return (
      <div className={classes}>
        <div className='Modal-header'>
          <h3 className='Modal-title'>{this.props.title}</h3>
          <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
            <Icon name='cross' mode='stroke' />
          </div>
        </div>

        <div className='Modal-content'>
          <p className='Modal-message'>
            To invite a {forZine ? 'contributor to your Collection' : 'friend'}, enter their email address below or connect <b>Facebook</b> and <b>Gmail</b> to import your contacts.
          </p>

          {forZine &&
            <p className='Modal-message'>
              Your Collection will appear in the <b>Suggested Collections</b> list of the users you have invited. They will be able to add stamps to your Collection after your approval.
            </p>
          }

          {this.renderContactImporter()}
          {this.renderForm()}

          {invited.length > 0 &&
            <h4 className='Modal-subtitle utils--smallCaps'>
              Invited
            </h4>
          }

          {invited.length > 0 &&
            <InviteList invites={invited}
                        reInvited={this.state.resentInvites}
                        onResendClick={this.handleResendClick} />
          }
        </div>
      </div>
    );
  },

  renderContactImporter: function () {
    var state = this.state,
        connectedServices = [];

    if (state.isFacebookConnected) {
      connectedServices.push(ServiceTypes.FACEBOOK);
    }

    if (state.isGoogleConnected) {
      connectedServices.push(ServiceTypes.GOOGLE);
    }

    return (
      <ContactImporter services={[ServiceTypes.FACEBOOK, ServiceTypes.GOOGLE]}
                       connectedServices={connectedServices}
                       onConnectClick={this.handleAccountConnect} />
    );
  },

  renderForm: function () {
    var state = this.state,
        recipient = state.recipient,
        tag = recipient.tags[0] || false,
        suggested = state.suggested;

    return (
      <div>
        <div className='Form'>
          <FormInputRow label='Enter name or email'
                        component={TagInput}
                        formLink={this.linkValidatedState('recipient', this.validateNameOrEmail)}
                        onBlur={this.handleRecipientBlur}
                        onKeyUp={this.handleRecipientKeyUp} />

          {suggested.length > 0 &&
            <ContactList contacts={suggested}
                         onSelect={this.handleSuggestedFriendSelect} />
          }

          {(!tag || tag.type !== ServiceTypes.FACEBOOK) &&
            <FormInputRow label='Add an optional message'
                          component={Textarea}
                          formLink={this.linkValidatedState('message', function () {})} />
          }


        </div>
        <Button className='SendInvite-button'
                color='green'
                onClick={this.submitForm.bind(this, this.sendInvite)}
                disabled={this.state.isSending}
                size='large'>
          Send an Invite
        </Button>
      </div>
    );
  },

  validateNameOrEmail: function (recipient, data) {
    if (recipient.text.length === 0 && recipient.tags.length === 0 && data.event === 'submit') {
      return { error: 'Name or email is required' };
    }

    if (data.event === 'tagBlur' || data.event === 'submit') {
      if (!isValidEmail(recipient.text) && recipient.tags.length === 0) {
        return { error: 'Invalid email' };
      }
    }
  },

  handleResendClick: function (invite) {
    if (this.state.isSending) { return; }

    if (invite.serviceType === ServiceTypes.FACEBOOK) {
      FacebookActionCreators.sendFacebookInvite(invite, true);
    } else {
      InvitationActionCreators.resendInvite(invite);
    }
  },

  sendInvite: function () {
    var state = this.state,
        zineSlug = this.props.zineSlug,
        recipient = state.recipient,
        tag = recipient.tags[0];

    if (!tag) {
      return;
    }

    InvitationActionCreators.sendInvite({
      serviceType: tag.type,
      serviceId: tag.user ? tag.user.contactId : tag.content,
      name: tag.user && tag.user.name,
      message: this.state.message,
      zineSlug: zineSlug
    });
  },

  handleAccountConnect: function (serviceType) {
    PopupManager.openConnect(serviceType, { scope: 'contacts' });
  },

  handleRecipientBlur: function () {
    var state = this.state,
        recipient = state.recipient,
        suggested = state.suggested;

    if (recipient.text.length > 0 &&
        suggested.length === 0 &&
        this.isFormValid({ event: 'tagBlur', showError: true })) {

      this.pushTagAndClearText({
        icon: 'email',
        type: ServiceTypes.EMAIL,
        content: recipient.text
      });
    } else if (suggested.length > 0) {
      this.clearSuggested();
    }
  },

  handleRecipientKeyUp: function (e) {
    if (!this.isEnterKey(e)) {
      return;
    }

    var suggested = this.state.suggested;
    if (suggested.length === 0) {
      return;
    }

    var firstSuggested = suggested[0],
        serviceType = firstSuggested.serviceType,
        content = firstSuggested.name;

    this.pushTagAndClearText({
      icon: serviceType === ServiceTypes.FACEBOOK ? 'facebook' : 'email',
      type: serviceType,
      content: content,
      user: firstSuggested
    });
  },

  handleSuggestedFriendSelect: function (friend) {
    var serviceType = friend.serviceType;

    this.pushTagAndClearText({
      icon: serviceType === ServiceTypes.FACEBOOK ? 'facebook' : 'email',
      type: serviceType,
      content: friend.name,
      user: friend
    });
  },

  pushTagAndClearText: function (tag) {
    SendInvitationFormActionCreators.pushTag(tag);
  },

  clearSuggested: function () {
    SendInvitationFormActionCreators.clearSuggested();
  }
});

module.exports = SendInvite;



/** WEBPACK FOOTER **
 ** ./modals/SendInvite.jsx
 **/